import { render, staticRenderFns } from "./viewMessage.vue?vue&type=template&id=dcd8436a&scoped=true&"
import script from "./viewMessage.vue?vue&type=script&lang=js&"
export * from "./viewMessage.vue?vue&type=script&lang=js&"
import style0 from "./viewMessage.vue?vue&type=style&index=0&id=dcd8436a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcd8436a",
  null
  
)

export default component.exports